module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_intro"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_XIII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("INTRODUCTION")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_XIII"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The first five books of the Bible, often called the Pentateuch, are fundamental to the faith of both Christians and Jews. These books contain the familiar stories of creation, the fall and the flood. They tell of the origins of the human race and of the Jewish people. They include laws as basic as the Ten Commandments and as complex as the regulations for food and sacrifices. These books relate the call of Israel to be God’s chosen people, yet hold out the prospect of universal salvation for all mankind. So profound has been the influence of these books on Western culture that their ideas are embedded in our language and ideology at point after point.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Yet anyone picking up a Bible and starting to read Genesis for the first time will soon be surprised, puzzled and sometimes shocked, for despite the Pentateuch’s foundational role in our culture, its ideas often seem utterly alien to the modern reader. Its approach to chronology, history, ethics and God challenge the modern world view at so many points that readers may be tempted to stop reading very quickly. But this would be a great mistake. The Pentateuch is a fascinating world, which deserves to be explored carefully and sympathetically. And this is what this volume tries to do.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XIII"
    }
  }, [_c('i', [_vm._v("Exploring the Old Testament ")]), _vm._v("is the general title of this series, and this first volume will try to guide you through the Pentateuch so that you can appreciate what it was trying to say to its first readers and why it should still be of interest to people living in the twenty-first century. I shall introduce you to the social world of the Bible, to its marriage customs, national festivals, welfare systems and legal ideals. I shall endeavour to illuminate the relationship between Israel and the surrounding cultures, the subtle mix of dependence and originality that characterizes the Pentateuch’s use of ancient Near Eastern ideas. We shall look at some of the literary techniques used in the Pentateuch, its love of symmetrical patterns and its rhetorical devices. But pre-eminently the Pentateuch speaks of God and his relationship to Israel mediated by Moses, so in exploring the ")]), _c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }, [_vm._v("book we shall try to come to terms with its theology, its ideas about God, its religious practices, its concepts of faith, obedience and loyalty.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }, [_vm._v("But a guide to the Pentateuch needs to be more than a description of what is there: it needs to explain something of the history of the study of the Pentateuch, of how scholars have come to understand it in the way they now do. It therefore contains, at various points, summaries of current scholarly debates, e.g. on patriarchal religion, or notes on recent archaeological discoveries. The later chapters of the book contain a more extended discussion of the composition of the Pentateuch, an issue that has been more fully debated by biblical scholars than any other topic. My treatment does not pretend to be comprehensive, just to give the first-time reader some bearings in a most complicated discussion.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }, [_vm._v("So how is this guide organized? Its opening chapters take you through the Pentateuch book by book explaining the contents and ideas of each book chapter by chapter, trying to show how the parts cohere as part of a larger whole. Frequently this running narrative is interrupted by diagrams, tables, maps or boxes headed ‘Digging deeper’. In them you will find short discussions on particular topics, or issues to be researched or reflected on. Often they pose questions without giving an answer. These digressions are important: they are designed to make you think about significant issues, e.g. slavery or famine relief, or make you try out the principles of literary criticism for yourself. I want you to get out of the tourist bus and explore the terrain yourself, before you move on to the next issue. When you have completed the suggested exercise, read on in the main text and you may find what I think about the issue I raised in the ‘Digging deeper’ box.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }, [_vm._v("Overseas travel often prompts thoughtful tourists to reflect on their own culture and to realize their own peculiarities. Reading the Pentateuch should have a similar effect, and sometimes I have tried to encourage this by asking reader- orientated questions in these ‘What do you think?’ boxes. In these cases I have usually avoided giving my opinion later in the text, as I do not want to impose my personal convictions on the reader.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }, [_vm._v("In the next chapters, on Theme, Composition and Rhetorical Function of the Pentateuch, I address issues that relate to all five books. Here I attempt to describe the major scholarly approaches to the original message, processes of composition and function of the Pentateuch. Of necessity this involves much summarizing of secondary literature in a rather descriptive way, but I have again tried to introduce interactive elements, challenging readers to try to reproduce the results of source analysis for themselves and to examine their own critical assumptions or those of the scholars who have argued for particular views.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }, [_vm._v("Finally let me point out that a guidebook is no substitute for visiting the place itself!")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XV"
    }
  }, [_vm._v("This "), _c('i', [_vm._v("Exploring the Old Testament ")]), _vm._v("series is designed to encourage the reading of the Bible, not replace it! I simply hope this volume will make the Pentateuch easier to grasp, and help you to appreciate its abiding power, beauty and relevance, and to share my enthusiasm for reading it.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_XV"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("ABD")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Anchor Bible Dictionary")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("BA")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Biblical Archaeologist")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("ESV")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("English Standard Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("JBL")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("JJS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Journal of Jewish Studies")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("JSOT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Journal for the Study of the Old Testament")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("JSOT Press")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Journal for the Study of the Old Testament Press")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("NIV")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("New International Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("NRSV")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("New Revised Standard Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("RSV")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Revised Standard Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("SBL Diss")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("VT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Vetus Testamentum")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("WTJ")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Westminster Theological Journal")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("ZAW")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31094265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre6.vue
// module id = 78
// module chunks = 0